import { render, staticRenderFns } from "./FacetTagMenuCount.vue?vue&type=template&id=523c3cb4&"
import script from "./FacetTagMenuCount.vue?vue&type=script&lang=js&"
export * from "./FacetTagMenuCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports